import { get, isEmpty } from 'lodash'

const isLoading = state => get(state, 'vista360ClientDashboardLoad.loading')
const hasErrors = state => !isEmpty(get(state, 'vista360ClientDashboardLoad.error'))

export const selectors = {
  isLoading,
  hasErrors,
}
